import { gql } from "apollo-boost"

export const getRfcValids = gql`
  query Query($submission: ID!, $concept: ID!) {
    validRFCBudget(
      submission: $submission
      concept: $concept
    )
  }
`